import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { LoginGuard } from "src/app/shared/login.guard";
import { AttributeFormComponent } from "../contract-master/attributes/attribute-form/attribute-form.component";
import { AttributeTypeListComponent } from "../contract-master/attributes/attribute-type-list/attribute-type-list.component";
import { AttributesComponent } from "../contract-master/attributes/attributes.component";
import { AddClauseComponent } from "../contract-master/clause/add-clause/add-clause.component";
import { ClauseListComponent } from "../contract-master/clause/clause-list/clause-list.component";
import { ClauseComponent } from "../contract-master/clause/clause.component";
import { ContractMasterComponent } from "../contract-master/contract-master.component";
import { ContractTypeFormComponent } from "../contract-master/contract-type/contract-type-form/contract-type-form.component";
import { ContractTypeListComponent } from "../contract-master/contract-type/contract-type-list/contract-type-list.component";
import { ContractTypeComponent } from "../contract-master/contract-type/contract-type.component";
import { ContractFormComponent } from "../contract-master/contract/contract-form/contract-form.component";
import { ContractListComponent } from "../contract-master/contract/contract-list/contract-list.component";
import { ContractComponent } from "../contract-master/contract/contract.component";
import { DashboardComponent } from "../contract-master/dashboard/dashboard.component";
import { TemplateComponent } from "../contract-master/template/template.component";
import { RoleFormComponent } from "../contract-master/user-management/role-form/role-form.component";
import { RoleListComponent } from "../contract-master/user-management/role-list/role-list.component";
import { UserFormComponent } from "../contract-master/user-management/user-form/user-form.component";
import { UserListComponent } from "../contract-master/user-management/user-list/user-list.component";
import { UserManagementComponent } from "../contract-master/user-management/user-management.component";
import { NotificationFormComponent } from "../notifications/notification-form/notification-form.component";
import { NotificationListComponent } from "../notifications/notification-list/notification-list.component";
import { NotificationMasterComponent } from "../notifications/notification-master/notification-master.component";
import { ReportsComponent } from "../contract-master/reports/reports.component";
import { OrganisationListComponent } from "../contract-master/user-management/organisation-list/organisation-list.component";
import { OrganisationFormComponent } from "../contract-master/user-management/organisation-form/organisation-form.component";
import { AboutComponent } from "../contract-master/about/about.component";
import { HelpMenuComponent } from "../contract-master/help-menu/help-menu.component";
import { SearchResultComponent } from "../contract-master/search-result/search-result.component";
import { ResultSearchComponent } from "../contract-master/result-search/result-search.component";
import { EmSignerComponent } from "../contract-master/em-signer/em-signer.component";
import { HelloSignComponent } from "../contract-master/hello-sign/hello-sign.component";
import { AccountMasterComponent } from "../contract-master/account-master/account-master.component";
import { AccountFormComponent } from "../contract-master/account-master/account-form/account-form.component";

const routes: Routes = [
  {
    path: "app",
    component: ContractMasterComponent,
    canActivate: [LoginGuard],
    children: [
      {
        path: "contract-type",
        component: ContractTypeComponent,
        canActivate: [LoginGuard],
        children: [
          {
            path: "list",
            component: ContractTypeListComponent,
            canActivate: [LoginGuard],
          },
          {
            path: ":mode/:id",
            component: ContractTypeFormComponent,
            canActivate: [LoginGuard],
          },
          {
            path: "add",
            component: ContractTypeFormComponent,
            canActivate: [LoginGuard],
          },
        ]
      },
      {
        path :"attributes",
        component:AttributesComponent,
        canActivate:[LoginGuard],
        children: [
          {
            path :"list",
            component:AttributeTypeListComponent,
            canActivate : [LoginGuard]
          },
          {
            path :"add",
            component:AttributeFormComponent,
            canActivate : [LoginGuard]
          },
          {
            path: ":mode/:id",
            component: AttributeFormComponent,
            canActivate: [LoginGuard],
          },
        ]
      },
      {
        path: "contract-template",
        component: TemplateComponent,
        canActivate: [LoginGuard],
      },
      {
        path: "contract",
        component: ContractComponent,
        canActivate: [LoginGuard],
        children: [
          {
            path: "add",
            component: ContractFormComponent,
            canActivate: [LoginGuard],
          },
          {
            path: ":mode/:id",
            component: ContractFormComponent,
            canActivate: [LoginGuard],
          },
          {
            path: "list",
            component: ContractListComponent,
            canActivate: [LoginGuard],
          },
        ],
      },
      {
        path: "clause",
        component: ClauseComponent,
        canActivate: [LoginGuard],
        children: [
          {
            path: "add",
            component: AddClauseComponent,
            canActivate: [LoginGuard],
          },
          {
            path: ":mode/:id",
            component: AddClauseComponent,
            canActivate: [LoginGuard],
          },
          {
            path: "list",
            component: ClauseListComponent,
            canActivate: [LoginGuard],
          },
        ],
      },
      {
        path: "dashboard",
        component: DashboardComponent,
        canActivate: [LoginGuard],
      },
      {
        path: "user",
        component: UserManagementComponent,
        canActivate: [LoginGuard],
        children: [
          {
            path: ":mode/:id",
            component: UserFormComponent,
          },
          {
            path: "add",
            component: UserFormComponent,
          },
          {
            path: "list",
            component: UserListComponent,
          },
        ],
      },
      {
        path: "role",
        component: UserManagementComponent,
        canActivate: [LoginGuard],
        children: [
          {
            path: ":mode/:id",
            component: RoleFormComponent,
          },
          {
            path: "add",
            component: RoleFormComponent,
          },
          {
            path: "list",
            component: RoleListComponent,
          },
        ],
      },
      {
        path: "notification",
        component: NotificationMasterComponent,
        canActivate: [LoginGuard],
        children: [
          {
            path: ":mode/:id",
            component: NotificationFormComponent,
          },
          {
            path: "list",
            component: NotificationListComponent,
          },
          {
            path: "add",
            component: NotificationFormComponent,
            canActivate: [LoginGuard],
          },
        ],
      },
      {
        path :"report",
        component : ReportsComponent,
        canActivate: [LoginGuard]
      },
      {
        path :"organisation/list",
        component : OrganisationListComponent,
        canActivate : [LoginGuard]
      },
      {
        path :"organisation/:mode/:id",
        component : OrganisationFormComponent,
        canActivate : [LoginGuard]
      },
      {
        path :"organisation/add",
        component : OrganisationFormComponent,
        canActivate : [LoginGuard]
      },
      {
        path:"about",
        component:AboutComponent,
        canActivate :[LoginGuard]
      },
      {
        path:"help",
        component:HelpMenuComponent,
        canActivate:[LoginGuard]
      },
      {
        path:"search",
        component:SearchResultComponent,
        canActivate:[LoginGuard]
      },
      {
        path:"result",
        component:ResultSearchComponent,
        canActivate:[LoginGuard]
      },
      {
        path: "em-signer",
        component: EmSignerComponent,
        canActivate: [LoginGuard]
      },
      {
        path: "hello-sign",
        component: HelloSignComponent,
        canActivate: [LoginGuard]
      },
      {
        path: "account-master",
        component: AccountMasterComponent,
        canActivate: [LoginGuard]
      },
      {
        path: "account-master/add",
        component: AccountFormComponent,
        canActivate: [LoginGuard]
      },
      {
        path: "account-master/edit/:id",
        component: AccountFormComponent,
        canActivate: [LoginGuard]
      },
      {
        path: "account-master/view/:id",
        component: AccountFormComponent,
        canActivate: [LoginGuard]
      }
    ],
  },
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: "reload",
    }),
  ],
  exports: [RouterModule],
})
export class ContractRoutingModule { }
export const contractRoutingComponents = [];
